import { Contact }                    from '../../types';
import { ContactState, ContactError } from '../../reduxTypes';
import { Reducer, Action }            from 'redux';
import ActionTypes                    from '../../ActionTypes';

interface LoadContact extends Action {
    contact: Contact,
    id: number
}

interface LoadContactError extends Action {
    error: ContactError
}

export const defaultState: ContactState = {
    contact: []
};

const ContactReducer: Reducer<ContactState> = (state: ContactState = defaultState, action: Action): ContactState => {
    switch (action.type) {
        case ActionTypes.CONTACT_LOADING:
        const { error, ...stateWithoutError } = state;

        return {
                ...stateWithoutError,
                loading: true
            };

        case ActionTypes.CONTACT_LOADED:
            return {
                contact: [...state.contact, {
                    ...(action as LoadContact).contact,
                    id: (action as LoadContact).id
                }]
            };

        case ActionTypes.CONTACT_LOAD_ERROR:
            return {
                ...state,
                loading: false,
                error: (action as LoadContactError).error
            };

        default:
            return state;
    }
};

export default ContactReducer;



// WEBPACK FOOTER //
// ./src/sections/Contact/ContactReducer.ts